import { PRIMARY_FONT } from "../../constants/fonts";
import palette from "../palette";

const { light, black } = palette;

const typography = {
  fontFamily: PRIMARY_FONT,

  body1: {
    color: light,
    fontWeight: '400',
    fontSize: '16px',

    '@media (max-width: 440px)': {
      fontSize: '12px',
    }
  },

  body2: {
    fontSize: '16px',
    fontWeight: '400',
    color: black
  },

  caption: {
    fontSize: '18px',
    fontWeight: '500'
  },

  subHeading: {
    fontSize: '16px',
  },

  subtitle1: {
    fontSize: '48px'
  },

  subtitle2: {
    fontSize: '14px',
    fontWeight: '400'
  },

  h4: {
    fontWeight: '700',
    fontSize: '24px',
    color: black,

    '@media (max-width: 440px)': {
      fontSize: '18px',
    },
  },

  h5: {
    fontWeight: '400',
    fontSize: '24px',
  },

  h6: {
    fontSize: '18px',
  },

  h3: {
    fontSize: '32px',
    fontWeight: '700',
  },

  h5_mobile: {
    fontSize: '20px',
    fontWeight: '700',
  },

  h2: {
    fontSize: '12px',
  },
}

export default typography;